/* tslint:disable */
/* eslint-disable */
/**
 * SmartAI WL
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ChatThreadModel,
  ChatThreadModelPagedList,
  SmartProblemDetails,
} from '../models/index';
import {
    ChatThreadModelFromJSON,
    ChatThreadModelToJSON,
    ChatThreadModelPagedListFromJSON,
    ChatThreadModelPagedListToJSON,
    SmartProblemDetailsFromJSON,
    SmartProblemDetailsToJSON,
} from '../models/index';

export interface DeleteThreadRequest {
    threadId: string;
}

export interface GetAllUserThreadsRequest {
    pageSize?: number;
    pageIndex?: number;
}

export interface GetThreadByIdRequest {
    threadId: string;
}

/**
 * 
 */
export class ThreadApi extends runtime.BaseAPI {

    /**
     */
    async deleteThreadRaw(requestParameters: DeleteThreadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['threadId'] == null) {
            throw new runtime.RequiredError(
                'threadId',
                'Required parameter "threadId" was null or undefined when calling deleteThread().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://852e32be-14b4-4154-884d-b9b5f479493f/access_as_user"]);
        }

        const response = await this.request({
            path: `/api/Thread/{threadId}`.replace(`{${"threadId"}}`, encodeURIComponent(String(requestParameters['threadId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteThread(requestParameters: DeleteThreadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteThreadRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getAllUserThreadsRaw(requestParameters: GetAllUserThreadsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChatThreadModelPagedList>> {
        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['PageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageIndex'] != null) {
            queryParameters['PageIndex'] = requestParameters['pageIndex'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://852e32be-14b4-4154-884d-b9b5f479493f/access_as_user"]);
        }

        const response = await this.request({
            path: `/api/Thread/All`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChatThreadModelPagedListFromJSON(jsonValue));
    }

    /**
     */
    async getAllUserThreads(requestParameters: GetAllUserThreadsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChatThreadModelPagedList> {
        const response = await this.getAllUserThreadsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getThreadByIdRaw(requestParameters: GetThreadByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChatThreadModel>> {
        if (requestParameters['threadId'] == null) {
            throw new runtime.RequiredError(
                'threadId',
                'Required parameter "threadId" was null or undefined when calling getThreadById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://852e32be-14b4-4154-884d-b9b5f479493f/access_as_user"]);
        }

        const response = await this.request({
            path: `/api/Thread/{threadId}`.replace(`{${"threadId"}}`, encodeURIComponent(String(requestParameters['threadId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChatThreadModelFromJSON(jsonValue));
    }

    /**
     */
    async getThreadById(requestParameters: GetThreadByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChatThreadModel> {
        const response = await this.getThreadByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
